import React from "react";

const routes = [
  // Not Found Page
  {
    element: React.lazy(() => import("./pages/auth/not-found")),
    path: "/not-found-page",
  },
  // Dashboard
  {
    element: React.lazy(() => import("./pages/dashboard")),
    path: "/",
    isValid: true,
  },
  // Manage Order
  {
    element: React.lazy(() =>
      import("./pages/manage-order/customer-order/index")
    ),
    path: "/customer-order",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/customer-order/detail")
    ),
    path: "/customer-order/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/customer-order/preview-upload")
    ),
    path: "/preview-upload",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/customer-order/modify-location")
    ),
    path: "/add/location",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/customer-order/modify-location")
    ),
    path: "/edit/location",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/customer-order/trip_planning")
    ),
    path: "/customer-order/trip-planning",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/customer-order/edit-route")
    ),
    path: "/edit-route",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/customer-order/order-confirmation")
    ),
    path: "/order-confirmation",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/dedicated-order/index")
    ),
    path: "/dedicated-order",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/dedicated-order/detail")
    ),
    path: "/dedicated-order/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/dedicated-order/orderby-dedicated-detail")
    ),
    path: "/orderby-dedicated/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-order/drop/index")),
    path: "/drop",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-order/drop/drop-clone")),
    path: "/drop-clone",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-order/detail-trip")),
    path: "/trip/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-order/order-planning")),
    path: "/order-planning",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/superkul-truck/index")
    ),
    path: "/superkul-truck",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/superkul-truck/index")
    ),
    path: "/superkul-truck/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/superkul-truck/edit-order-truck")
    ),
    path: "/superkul-truck/add",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-order/superkul-truck/edit-order-truck")
    ),
    path: "/superkul-truck/:id/edit",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-order/pre-order")),
    path: "/pre-order",
    isValid: true,
  },

  // Manage Trip
  {
    element: React.lazy(() => import("./pages/manage-trip/trip-planning")),
    path: "/trip-planning",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-trip/rejected-trip")),
    path: "/rejected-trip",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-trip/all-trip")),
    path: "/all-trip",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-trip/detail-trip")),
    path: "/manage-trip/:id/detail",
    isValid: true,
  },

  // Fullfillment Service
  {
    element: React.lazy(() =>
      import("./pages/fullfillment-service/data-crossdocking")
    ),
    path: "/data-crossdocking",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/fullfillment-service/detail-crossdocking")
    ),
    path: "/data-crossdocking/:id/detail",
    isValid: true,
  },

  // Finance Report
  {
    element: React.lazy(() =>
      import("./pages/finance-report/invoice-truck/index")
    ),
    path: "/invoice-truck",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/invoice-truck/index")
    ),
    path: "/invoice-truck/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/invoice-truck/edit-invoice-truck")
    ),
    path: "/invoice-truck/add",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/invoice-truck/edit-invoice-truck")
    ),
    path: "/invoice-truck/:id/edit",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/withdrawal-vendor")
    ),
    path: "/withdrawal-vendor",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/withdrawal-driver/withdrawal-driver")
    ),
    path: "/withdrawal-driver",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/additional-driver-transactions")
    ),
    path: "/additional-driver-transactions",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/withdrawal-driver/deposit-history")
    ),
    path: "/deposit-history/:id",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/finance-report/invoice-order")),
    path: "/invoice-order",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/invoice-order/detail")
    ),
    path: "/invoice-order/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/invoice-order/detail")
    ),
    path: "/invoice-order/additional/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/invoice-order/detail-crossdock")
    ),
    path: "/invoice-order/crossdock/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/deposit-analysis")
    ),
    path: "/deposit-analysis",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/finance-report/driver-wallet")),
    path: "/driver-wallet",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/driver-wallet/detail")
    ),
    path: "/driver-wallet/:id/detail/:profileId",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/drop-incentive/drop-incentive")
    ),
    path: "/drop-incentive",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/drop-incentive/detail")
    ),
    path: "/drop-incentive/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/finance-report/drop-incentive/detail")
    ),
    path: "/drop-incentive/:id/history/detail",
    isValid: true,
  },
  // Manage Driver
  {
    element: React.lazy(() => import("./pages/manage-driver/list-driver")),
    path: "/list-driver",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-driver/request-maintenance")
    ),
    path: "/request-maintenance",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-driver/detail-driver")),
    path: "/manage-driver/:id/detail",
    isValid: true,
  },

  // Detail driver (tab based)
  {
    element: React.lazy(() => import("./pages/manage-driver/detail-driver")),
    path: "/manage-driver/:id/:tab/detail",
    isValid: true,
  },

  {
    element: React.lazy(() => import("./pages/manage-driver/attendance")),
    path: "/attendance",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-driver/rating")),
    path: "/rating",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-driver/driver-schedule")),
    path: "/driver-schedule-clone",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/manage-driver/Schedule/schedule")
    ),
    path: "/driver-schedule",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/manage-driver/request-timeoff")),
    path: "/request-timeoff",
    isValid: true,
  },

  // Master Data
  {
    element: React.lazy(() => import("./pages/master-data/customer")),
    path: "/customer",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/vendor/detail")),
    path: "/vendor/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/vendor/index")),
    path: "/vendor",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/master-data/customer-corporate/index")
    ),
    path: "/customer-corporate",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/master-data/customer-corporate/detail-corporate")
    ),
    path: "/customer-corporate/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/master-data/customer-corporate/detail-request")
    ),
    path: "/customer-request/:id/detail",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/master-data/customer-address-label")
    ),
    path: "/customer-address-label",
    isValid: true,
  },

  {
    element: React.lazy(() => import("./pages/master-data/outsource")),
    path: "/outsource",
    isValid: true,
  },

  {
    element: React.lazy(() => import("./pages/master-data/driver-rate")),
    path: "/driver-rate",
    isValid: true,
  },

  {
    element: React.lazy(() => import("./pages/master-data/driver-incentive")),
    path: "/driver-incentive",
    isValid: true,
  },

  {
    element: React.lazy(() => import("./pages/master-data/service-price")),
    path: "/service-price",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/promo")),
    path: "/promo",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/package-category")),
    path: "/package-category",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/additional-service")),
    path: "/additional-service",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/price-based")),
    path: "/price-based",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/price-superkul")),
    path: "/price-superkul",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/service-name")),
    path: "/service-name",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/vehicle")),
    path: "/vehicle",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/master-data/vehicle-types/index")
    ),
    path: "/vehicle-type",
    isValid: true,
  },
  {
    element: React.lazy(() =>
      import("./pages/master-data/vehicle-types/detail")
    ),
    path: "/vehicle-type/:id/detail",
    isValid: true,
  },

  {
    element: React.lazy(() => import("./pages/master-data/pool")),
    path: "/pool",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/warehouse")),
    path: "/warehouse",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/master-data/driver-work")),
    path: "/driver-work",
    isValid: true,
  },

  // Role Management
  {
    element: React.lazy(() => import("./pages/role-management/index")),
    path: "/role-management",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/role-management/modify-role")),
    path: "/add/role-management",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/role-management/modify-role")),
    path: "/role-management/:id/edit",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/role-management/detail")),
    path: "/role-management/:id/detail",
    isValid: true,
  },
  // User Management
  {
    element: React.lazy(() => import("./pages/user-management/index")),
    path: "/user-management",
    isValid: true,
  },
  // Performance Report
  {
    element: React.lazy(() =>
      import("./pages/analytic/performance-report/index")
    ),
    path: "/performance-report",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/analytic/gross-margin/index")),
    path: "/gross-margin-analytic",
    isValid: true,
  },
  // Manage Complain
  {
    element: React.lazy(() => import("./pages/manage-complaint/index")),
    path: "/manage-complain",
    isValid: true,
  },
  // Settings
  {
    element: React.lazy(() => import("./pages/setting/privacy-policy")),
    path: "/privacy-policy",
    isValid: true,
  },
  {
    element: React.lazy(() => import("./pages/setting/terms-conditions")),
    path: "/terms-conditions",
    isValid: true,
  },
];

export default routes;
